import { render, staticRenderFns } from "./BaseGearCard.vue?vue&type=template&id=224a56d6&"
import script from "./BaseGearCard.vue?vue&type=script&lang=js&"
export * from "./BaseGearCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseGearCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports